var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupOutlookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 178 178",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0072c6",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112 39v34.366l12.006 7.562c.317.093 1.003.1 1.32 0l51.674-34.848c0-4.124-3.846-7.08-6.016-7.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.007 85.604 10.955 7.64c1.543 1.152 3.403 0 3.403 0-1.853 1.153 50.635-34.244 50.635-34.244v64.096c0 6.978-4.4 9.904-9.346 9.904h-55.654v-47.396zm-57.929-15.804c-3.753 0-6.744 1.77-8.952 5.306-2.208 3.535-3.316 8.216-3.316 14.042 0 5.912 1.108 10.586 3.316 14.022 2.208 3.442 5.106 5.153 8.687 5.153 3.694 0 6.625-1.671 8.786-5.014 2.162-3.342 3.25-7.983 3.25-13.915 0-6.185-1.048-10.999-3.15-14.441-2.102-3.436-4.974-5.154-8.62-5.154z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.823 20.563v135.657l102.787 21.64v-177.271zm68.78 90.763c-4.343 5.74-10.006 8.615-16.996 8.615-6.81 0-12.354-2.783-16.644-8.342-4.284-5.566-6.433-12.81-6.433-21.745 0-9.435 2.175-17.065 6.532-22.89 4.357-5.827 10.126-8.743 17.308-8.743 6.784 0 12.274 2.783 16.459 8.363 4.19 5.579 6.286 12.93 6.286 22.058.007 9.381-2.168 16.945-6.512 22.684z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupOutlookLogo);
export default __webpack_public_path__ + "static/media/SignupOutlookLogo.3d1a6438f4ff39c051131c4ada10ea7f.svg";
export { ForwardRef as ReactComponent };